import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  ColorBean,
  ColorSearchCriteria,
  RestColorListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class ColorListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.searchRef = React.createRef();
    this.state = {};
  }
  componentDidMount() { }
  componentDidUpdate() {
    this.setInputFocus();
    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms(e);
  };

  editColorSearch = (e, val, rowData) => {
    if (e.detail === 1) this.props.editColorSearch(val, rowData);
  };
  deleteColor = (e, rowData) => {
    if (e.detail === 1) this.props.deleteColor(rowData);
  };
  buttonCancelClickCallback = () => {
    this.props.buttonCancelClickCallback();
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };

  filterOnChange = (e) => {
    this.props.filterOnChange(e);
  }
  filterColor = (e) => {
    if (e.detail === 1) this.props.filterColor(e);
  }

  resetColor = (e) => {
    if (e.detail === 1) this.props.resetColor(e);
  }
  render() {
    let color_list = this.props.color_list;
    return (
      <div>
        <Row>

          <Col sm="1">
            <FormLabel id="searchBarLabel">Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              //  ref={this.listFormCodeRef}
              type="text"
              name="code"
              onChange={this.props.onChange}
              value={this.props.colorData.code}
              style={{ "text-transform": "uppercase" }}
              enterKeyEventHandler={this.props.enterKeyEventHandler}
              isMandatory={true}
            ></InputTextbox>
          </Col>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              className="text-center"
              onClick={(e) => this.opentypeforms(e)}
            >
              Go
            </Button>
          </Col>



          <Col sm="1">
            <FormLabel >Search</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.searchRef}
              type="text"
              name="codeContains"
              onChange={this.props.filterOnChange}
              value={this.props.criteria.codeContains}
            ></InputTextbox>
          </Col>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              className="text-center"
              onClick={(e) => this.filterColor(e)}
            >
              Filter
            </Button>

            <Button
              id="fabric_Add_Button"
              className="text-center"
              onClick={(e) => this.resetColor(e)}
            >
              Reset
            </Button>
          </Col>

          <Col sm="1">

          </Col>
        </Row>
        <br />
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {color_list != null ? (
              <tbody>
                {color_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editColorSearch(e, Info.code, Info)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* {Info.isApplied == false ? (
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.deleteColor(e, Info.code)}
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    ) : (
                      <Button
                        variant="secondry"
                        onClick={(e) => this.buttonCancelClickCallback(e)}
                      >
                        {<DeleteIcon />}
                      </Button>
                    )} */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {color_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class ColorEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  componentDidUpdate() { }

  onChange = (e) => {
    this.props.onChange(e);
  };
  saveColor = (e) => {
    this.props.saveColor(this.state.colorData);
  };

  closeColorEntryForm() {
    this.props.closeColorEntryForm();
  }
  render() {
    let colorData = this.props.colorData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={colorData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Color Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter ColorCode"
              onChange={this.onChange}
              value={colorData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={colorData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Nrf Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="nrfCode"
              type="text"
              placeholder="Enter NrfCode"
              onChange={this.onChange}
              value={colorData.nrfCode}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={colorData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}
class ColorList extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      color_list: [],
      response: {},
      pageTitle: "Color",
      colorData: new ColorBean(),
      pageList: new PageListBean(),
      criteria: new ColorSearchCriteria(),
      companyCode: "",
      isShowExitButton: true,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isColorListFormOpen: true,
      isColorEntryFormOpen: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isDisableFields: false,
      order: "asc",
      sortField: "",
      colorCode: "",
      tempColorList: [],
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
    this.setState({ isShowCode: false });
  }
  moduleCaption = "Color";

  cleardata = () => {
    let colorData = new ColorBean();
    colorData.companyCode = this.companyCode;
    this.setState({ colorData: colorData });
  };
  onChange = (e) => {
    let temp_colordata = this.state.colorData;
    temp_colordata[e.target.name] = e.target.value;
    this.setState({
      colorData: temp_colordata,
    });
  };

  filterOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({
      criteria: criteria,
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = (e) => {
    let colorCode = this.state.colorData;
    this.editColorSearch(colorCode.code);
  };
  saveColorResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeColorEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };
  saveColor = (colorData) => {
    if (colorData.isFetched == true) {
      if (SecurityAccessManager.ColorMaintenanceEdit_IsAccessible()) {
        MasterService.updateColor(
          colorData,
          this.saveColorResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.ColorMaintenanceCreate_IsAccessible()) {
        MasterService.createColor(
          colorData,
          this.saveColorResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  editColorResponse = (response) => {
    if (response.data != null) {
      if (response.data.colorBean != null) {
        let colorData = response.data.colorBean;
        this.setState({
          colorData: colorData,
        });
        this.disable();
      }
    }
    this.openColorEntryForm();
  };
  editColorSearch = (colorCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = colorCode;
    if (SecurityAccessManager.ColorMaintenanceView_IsAccessible()) {
      MasterService.readColor(
        readrestInput,
        this.editColorResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let colorData = this.state.colorData;
    colorData.companyCode = this.companyCode;
    colorData.code = this.state.colorData.code.toUpperCase();
    this.clearError();
    this.saveColor(colorData);
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeColorEntryForm();
    this.componentDidMount();
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };
  openColorEntryForm = () => {
    this.setState({
      isColorListFormOpen: false,
      isColorEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      criteria: new ColorSearchCriteria(),
    });
    this.hideAlertCallBack();
  };

  closeColorEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isColorListFormOpen: true,
      isColorEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      criteria: new ColorSearchCriteria(),
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadColorResponse = (response) => {
    if (response.data != null && response.data.colorPageList != null) {
      let color_list = new Array();
      if (!isEmptyArray(response.data.colorPageList.colors)) {
        color_list = response.data.colorPageList.colors;
        color_list.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.colorPageList.currentPage;
      pageList.pageSize = response.data.colorPageList.pageSize;
      pageList.totalCount = response.data.colorPageList.totalCount;
      this.setState({
        color_list: color_list,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadColorPage(pageInput, criteria);
  };
  loadColorPage = (pageList, searchCriteria) => {
    let criteria = new ColorSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestColorListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.ColorMaintenanceView_IsAccessible()) {
      MasterService.getColorPageList(
        requestInput,
        this.loadColorResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  buttonCancelClickCallback = () => {
    let empArray = [];
    let errorMessage = "Access Denied";
    empArray.push(errorMessage);
    this.setState({
      alertMessage: empArray,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  deleteColor = (rowData) => {
    let criteria = new ColorSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData;
    if (SecurityAccessManager.ColorMaintenanceDelete_IsAccessible()) {
      MasterService.deleteColor(
        criteria,
        this.deleteColorResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteColorResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.color_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ color_list: sorted });
    }
  };
  filterColor = () => {
    // let criteria = this.state.criteria;
    // criteria.companyCode = this.companyCode;
    // let pageList = this.state.pageList;
    // let pageInput = new PageListBean();
    // pageInput.pageSize = 50;
    // pageInput.currentPage = 1;
    // if (pageList != null) pageInput.totalCount = pageList.totalCount;
    // this.state.pageList = pageInput;
    // this.loadColorPage(pageInput, criteria);
     this.loadPage(1);

  };
  resetColor = () => {
    let criteria = new ColorSearchCriteria();
    this.setState({ criteria: criteria }, () => {
      this.loadPage(1);
    });
  }
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isColorListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}
        {!this.state.isColorListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isColorListFormOpen && (
          <ColorListForm
            color_list={this.state.color_list}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            onChange={this.onChange}
            opentypeforms={this.openColorEntryForm}
            colorData={this.state.colorData}
            editColorSearch={this.editColorSearch}
            deleteColor={this.deleteColor}
            buttonCancelClickCallback={this.buttonCancelClickCallback}
            enterKeyEventHandler={this.enterKeyEventHandler}
            handleSortingChange={this.handleSortingChange}
            filterOnChange={this.filterOnChange}
            filterColor={this.filterColor}
            resetColor={this.resetColor}
          />
        )}
        {this.state.isColorEntryFormOpen && (
          <ColorEntryForm
            colorData={this.state.colorData}
            closeColorEntryForm={this.closeColorEntryForm}
            saveColor={this.saveColor}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}
function ColorAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <ColorList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default ColorAttributeModule;
